export const AI_CONTEXT_ACTION_TRANSITION =
  "background 2000ms cubic-bezier(0.22, 0.71, 0.28, 0.9), border-color 100ms ease, box-shadow 2000ms ease, color 500ms cubic-bezier(0.33, 0.69, 0.43, 0.76)";
